function observeShadowAndInjectStyle() {
  const host = document.querySelector('checkout-plus');
  if (!host) return;
  const waitShadow = setInterval(() => {
    if (host.shadowRoot) {
      clearInterval(waitShadow);

      const shadow = host.shadowRoot;

      const observer = new MutationObserver(() => {
        const target = shadow.querySelector('.dual-button-container');

        if (target && !shadow.querySelector('#custom-style')) {
          const style = document.createElement('style');
          style.id = 'custom-style';

          style.textContent = `
            .dual-button-container .product-info {
              border: none !important;
              padding: 0px 0px 8px !important;
            }
            .product-title{
              font-size: 14px !important;
              color: #333 !important;
            }
            .custom-content button{
              font-size: 13px !important;
            }
            .product-price {
              color: #333 !important;
              padding-top: 2px !important;
            }
            .info-icon{
              top: 6px !important;
            }
          `;

          shadow.appendChild(style);
        }
      });

      observer.observe(shadow, {
        childList: true,
        subtree: true
      });
    }
  }, 50);
}

/** Theme setting: Protect My Order product — excluded from drawer, count bubble, and progress thresholds (checkout total unchanged). */
function getProtectionCartAdjustments(cartData) {
  const pid = window.protectionProductId;
  if (pid == null || pid === '' || !cartData || !Array.isArray(cartData.items)) {
    return { protectionQty: 0, protectionCents: 0 };
  }
  let protectionQty = 0;
  let protectionCents = 0;
  cartData.items.forEach((item) => {
    if (item.product_id == null) return;
    if (String(item.product_id) !== String(pid)) return;
    protectionQty += item.quantity || 0;
    const lineAmt =
      item.final_line_price != null ? item.final_line_price : item.line_price != null ? item.line_price : 0;
    protectionCents += lineAmt;
  });
  return { protectionQty, protectionCents };
}

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.mulVariantOptions = ['Color', 'Select Your Set'];
    this.cartIconButton = document.getElementById('cart-icon-bubble');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.body = document.querySelector('body');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.swiperCartClaim = null;
    this.slideElementsMap = new Map();
  this.cartGiftSelections = []; // FIFO order tracking for cart gift selections

    // Cart Progress bar (Shipping & Gifts)
    this.cartConfig = JSON.parse(this.querySelector('[data-section-settings]').getAttribute('data-section-settings'));
    this.cartConfigThreshold = this.cartConfig.threshold;
    this.cartLargestThreshold = 0;
    for (const [key, value] of Object.entries(this.cartConfigThreshold)) {
      if(this.cartLargestThreshold < value)
        this.cartLargestThreshold = value;
    }

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('[data-close-cart-drawer]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );


    this.cartIconButton.addEventListener('click', this.open.bind(this))

    // add event on quantity
    if(document.querySelectorAll('.cart-notification__body .quantity__input').length) {
      this.quantityInput();
    }






    this.initRecommendations();

    this.initializeRemoveListeners();

    this.initCartGift();

    window.addEventListener('resize', () => {
      this.setScreenHeight();
    });
  }



  initRecommendations(){
    // Helper function to format monetary amounts consistently
    const formatAmount = (amount) => {
      const roundedAmount = Math.floor(amount/100) * 100;
      return formatMoney(roundedAmount).replace(/\.\d+/, '');
    };


    var allNostoElements = document.querySelectorAll(".nosto_element.nosto_element__sidebar .cart__item");

    var cartObj = this;
    allNostoElements.forEach(async function(nostoElementItem) {
      var button = nostoElementItem;
      // Log the data-variant-id attribute
      var productHandle = button.getAttribute('data-handle');
      var productId = button.getAttribute('data-product-id');
      var variantId = button.getAttribute('data-variant-id');
      // Fetch product data from preloaded data
      var product;
      var result = await fetch(`${window.routes.root_url}/products/${productHandle}?view=jsonview`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      if(result.status === 200) {
        product = await result.json();
      }
      // var product = window.preloadedProducts[productId];
      const cartNotification = document.querySelector("cart-notification");
      // && cartNotification.mulVariantOptions.includes(product.options[0])
      if (product && product.id && product.variants.length > 1) {
        let item = product.variants[0];
        const variants = product.variants;
        variants.map((variant, variantIndex) => {
          if(variant.available && item == product.variants[0]){
            item = variant;
          }
        });
        var variantPickerHTML = `
        <div class="cart-item__variant-picker">
          <div class="variant-picker__content">
            <div class="cart-notification__header">
              <h2 class="cart-notification__heading caption-large text-body">Select Shade</h2>
              <button type="button" class="variant-picker__close link link--text focus-inset">
                <img src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/close.svg?v=1725933626" width="24" height="24">
              </button>
            </div>
            <div class="cart-item" data-variant-id="${item.id}">
              <div class="cart-item__media">
                <img class="cart-item__image"
                  src="${ product.featured_image.src }"
                  loading="lazy"
                  width="240"
                  height="240"
                >
              </div>
              <div class="cart-item__right">
                <div class="cart-item__details">
                  <a href="${product.url}" class="cart-item__name h4 break">
                    ${product.title}
                    <p class="cart-item__property">${item.title.split("__")[0]}</p>
                  </a>
                  ${item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${item.selling_plan_allocation.selling_plan.name}</p>` : ''}
                  <div class="cart-item__quantity">
                      <div class="cart-item__quantity-wrapper">
                        <quantity-input class="quantity">
                          <button class="quantity__button no-js-hidden" name="minus" type="button">
                            <span class="visually-hidden">decrease ${product.title}</span>
                            <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
                              <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                            </svg>
                          </button>
                          <input class="quantity__input" type="number" name="updates[]" variant-id="${product.id}" value="1" min="0" aria-label="${product.title}" id="Quantity-${item.id}" data-index="${item.id}">
                          <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">increase ${product.title}</span>
                            <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
                              <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                <path d="M8,1 L8,15"></path>
                                <path d="M1,8 L15,8"></path>
                              </g>
                            </svg>
                          </button>
                        </quantity-input>
                      </div>
                    </div>

                  </div>
              </div>

              <div class="cart-item__options">
                <div class="cart-item__price">
                  <span class="cart-item__price-compare">${formatAmount(product.price)}</span>
                </div>
              </div>
            </div>
            <variant-radios class="no-js-hidden swatch_round" data-section data-url="/products/${productHandle}">
              <div class="cart-item__active-variant">
                <div class="active-variant__content">
                  ${(() => {
                    const firstVariant = item; // Access the first variant directly
                    const swatchColor = firstVariant.metafields.swatch_color || 'transparent';
                    const variantTitle = firstVariant.name || 'Unknown Variant';

                    const swatchFile = firstVariant ? firstVariant.metafields.swatch_img: '';
                    if(swatchFile && (!swatchColor || swatchColor == 'transparent')){
                       return `
                        <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;">
                          <img src="${ swatchFile }" loading="lazy" width="58" height="58">
                        </span>
                        <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                      `;
                    }
                    return `
                      <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;"></span>
                      <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                    `;
                  })()}
                </div>
                <img class="active-variant__close inverted" src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/arrow-down.svg?v=1725933654" height="24" width="24">
              </div>
              <div class="active-variant__drawer">

              </div>

              <script type="application/json">
                ${JSON.stringify(variants)}
              </script>
            </variant-radios>
            <div class="cart-notification__footer footer__static">
              <div class="cart_drawer_formBox">
                ${(() => {
                  const firstVariant = item; // Access the first variant directly
                  return `
                    <button type="button" class="button btn variant-update__btn variant-update__nosto" data-variant-id="${firstVariant.id}" data-quantity="${ item.quantity }">
                      <span class="btn__text button--full-width">Add To Cart</span>
                      <span id="button__price" class="button__price nosto-price">${formatAmount(firstVariant.price)}</span>
                    </button>
                  `;
                })()}
              </div>
            </div>
          </div>
        </div>
      `;

      // Append the variant picker into the .cart-item__variant-preloaded div
      var variantPickerContainer = document.querySelector('.cart-item__variant-preloaded');
      if (variantPickerContainer) {
        // Add a unique identifier to the variant picker HTML
        var uniqueId = 'variant-picker-' + productId;
        variantPickerHTML = variantPickerHTML.replace('<div class="cart-item__variant-picker">', `<div class="cart-item__variant-picker" data-variant-picker-id="${uniqueId}" data-product-handle="${productHandle }">`);
        variantPickerContainer.insertAdjacentHTML('beforeend', variantPickerHTML);

        // Store a reference to the newly inserted variant picker using the unique identifier
        var variantPicker = variantPickerContainer.querySelector(`[data-variant-picker-id="${uniqueId}"]`);

        // Find the closest .cart__item or .cart__item-upsell element
        var closestCartItem = button.closest('.cart__item, .cart__item-upsell');
        // Add a new click listener to open the variant picker
        closestCartItem.addEventListener('click', async function(event) {
          event.preventDefault();

          // Close all other variant pickers
          var allVariantPickers = document.querySelectorAll('.variant-picker__expanded');
          allVariantPickers.forEach(function(picker) {
            if(picker.classList.contains('one-time')){
              picker.remove();
            }else{
              picker.classList.remove('variant-picker__expanded');
              picker.querySelector(".active-variant__drawer").innerHTML = ""
            }
          });

          // Logic to open the variant picker
          if (variantPicker) {
            variantPicker.classList.add('variant-picker__expanded');
            // Initialize the variant picker
            let variantRadios = variantPicker.querySelector('variant-radios');
            variantRadios.updateCartNotification();
          }
        });

        if (variantPicker) {
          // Add close button listener
          const closeButton = variantPicker.querySelector('.variant-picker__close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              // Handle close button logic here
              if(variantPicker.classList.contains('one-time')){
                variantPicker.remove();
              }else{
                variantPicker.classList.remove('variant-picker__expanded');
                variantPicker.querySelector(".active-variant__drawer").innerHTML = ""
                // Reset footer z-index to 999 when variant picker closes, overriding !important
                document.querySelector('.cart-notification__footer.footer__main').style.setProperty('z-index', '999', 'important');
              }
            });
          }
        }
      }

      } else if(variantId){
         var closestCartItem = button.closest('.cart__item, .cart__item-upsell');
        // Add a new click listener to open the variant picker
        closestCartItem.addEventListener('click', async function(event) {
          event.preventDefault();
          // addVariant
          fetch('/cart/add.js', {
              body: JSON.stringify({ id: variantId, quantity: 1 }),
              credentials: "same-origin",
              method: "POST",
              headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          })
          .then((response) => response.json())
          .then((response) => {
            cartObj.renderContents();
          });
        })

      }

    });
  }

  open() {
    const pageOverlay = document.querySelector('.cart-notification__overlay');

    this.setScreenHeight(); // ios fix
    if (this.header) this.header.reveal();

    this.body.classList.add('no-scroll');
    pageOverlay.classList.add('active');
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    const cartBody = this.notification.querySelector('.cart-notification__body');
    cartBody.style.overflow = 'scroll';
    cartBody.style.position = 'static';

    if (window.innerWidth > 989) {
      let nostoElement = document.querySelector('.nosto_element__dropdown');
      const cartFooter = this.notification.querySelector('.cart-notification__footer.footer__main')
      cartFooter.classList.add('animate');

      setTimeout(() => {
        nostoElement.classList.add('nosto_element--expanded');
      }, 350);
    }

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    const pageOverlay = document.querySelector('.cart-notification__overlay');
    if (window.innerWidth > 989) {
      let nostoElement = document.querySelector('.nosto_element__dropdown');
      nostoElement.classList.remove('nosto_element--expanded');
    }

    setTimeout(() => {
      pageOverlay.classList.remove('active');
      this.body.classList.remove('no-scroll');
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.activeElement);
      const cartFooter = this.notification.querySelector('.cart-notification__footer.footer__main');
      cartFooter.classList.remove('animate');
    }, 100);

    setTimeout(() => {
      const cartBody = this.notification.querySelector('.cart-notification__body');
      cartBody.style.overflowY = 'hidden';
      cartBody.style.position = 'relative';
      const cartItems = document.querySelectorAll('#cart-items .cart-item');
    }, 500);

  }

  async validateGWPProducts() {
    const cartData = await window.getCart();
    const gwpItems = cartData.items.filter(item => item.product_type === 'GWP');
    const nonGwpItems = cartData.items.filter(item => item.product_type !== 'GWP');

    // If there are GWP items and no non-GWP items, remove the GWP items
    if (gwpItems.length > 0 && nonGwpItems.length === 0) {
      const removeArray = {};
      gwpItems.forEach(item => {
        removeArray[item.id] = 0;
      });

      try {
        await window.removeGiftProduct(removeArray);
        // Validate slides after removing GWP products
      } catch (error) {
        console.error('Failed to remove GWP products:', error);
      }
    }
  }

  async validateSlides() {
    const cartData = await window.getCart();
    const cartItems = cartData.items.map(item => item.id.toString());
    const processedVariants = new Set(); // Set to keep track of processed variant IDs
    const slidesToRemove = [];
    const claimLimit = window.claimLimit; // Get the claim limit from the global variable

    // Reinsert slides back into the slider from slideElementsMap
    this.slideElementsMap.forEach((value, key) => {
      const slideElement = document.createElement('div');
      slideElement.classList.add('swiper-slide');
      slideElement.innerHTML = value.html;
      this.swiperCartClaim.appendSlide(slideElement);
    });

    console.log(this.slideElementsMap, 'this.slideElementsMap');

    // Clear the slideElementsMap after reinserting the slides
    // this.slideElementsMap.clear();

    // Reinitialize the Swiper instance
    this.swiperCartClaim.update();
    this.swiperCartClaim.loopCreate();

    // Iterate over the actual slider elements on the page
    Array.from(this.swiperCartClaim.slides).forEach(slide => {
      const productDataElement = slide.querySelector('.cart-item__media img');
      if (productDataElement) {
        const dataProduct = productDataElement.getAttribute('data-product');
        try {
          const productData = JSON.parse(dataProduct);
          const variantId = productData.variants[0].id;

          if (cartItems.includes(variantId.toString())) {
            const ariaLabel = slide.getAttribute('aria-label');
            const slidePosition = parseInt(ariaLabel.split('/')[0], 10) - 1;

            // Check if the variant ID has already been processed
            if (!processedVariants.has(variantId) && !slide.classList.contains('swiper-slide-duplicate')) {
              // Save the active and non-duplicate slide element and its index in the Map before removing it
              this.slideElementsMap.set(variantId, { html: slide.outerHTML, index: slidePosition });

              // Mark the variant ID as processed
              processedVariants.add(variantId);

              // Add the slide position to the list of slides to remove
              slidesToRemove.push(slidePosition);
            }
          }
        } catch (error) {
          console.error('Error parsing product data:', error);
        }
      }
    });

    // Destroy the loop, remove all slides, and then create and update the loop
    if (slidesToRemove.length > 0) {
      this.swiperCartClaim.loopDestroy();

      // Sort slide positions in descending order to avoid index shifting issues
      slidesToRemove.sort((a, b) => b - a);

      slidesToRemove.forEach(slidePosition => {
        this.swiperCartClaim.removeSlide(slidePosition);
      });

      // Update Swiper to reflect the removed slides
      this.swiperCartClaim.update();

      // Check the number of remaining unique slides
      const uniqueSlides = Array.from(this.swiperCartClaim.slides).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

      if (uniqueSlides.length > 1) {
        this.swiperCartClaim.loopCreate();
        this.swiperCartClaim.update();

        // Show navigation arrows
        document.querySelector('.swiper-button-next').style.display = 'block';
        document.querySelector('.swiper-button-prev').style.display = 'block';
      } else {
        // Remove all duplicate slides if there is only one unique slide
        const duplicateSlides = Array.from(this.swiperCartClaim.slides).filter(slide => slide.classList.contains('swiper-slide-duplicate'));
        duplicateSlides.forEach(duplicateSlide => duplicateSlide.remove());

        // Update Swiper to reflect the removal of duplicate slides
        this.swiperCartClaim.update();

        // Hide navigation arrows
        document.querySelector('.swiper-button-next').style.display = 'none';
        document.querySelector('.swiper-button-prev').style.display = 'none';
      }
    }

    // Check if the claimed count exceeds or equals the claim limit
    const claimedCount = this.slideElementsMap.size;

    const cartClaimWrapper = document.querySelector('.cart-claim__wrapper');

     var freeShipping = window.freeShipping.shipping[0],
         freeClaimPrice = (freeShipping.freeClaimThreshold * 100);

    const exchangeRate = parseFloat(window.Shopify.currency.rate);

    const freeClaimPriceLocal = (freeClaimPrice / 100) *  exchangeRate * 100;
    const claimCartTotal =
      cartData.total_price - getProtectionCartAdjustments(cartData).protectionCents;
    if (claimCartTotal > freeClaimPriceLocal && cartClaimWrapper) {
      if (claimedCount >= claimLimit) {
        cartClaimWrapper.classList.add('hidden');
      } else {
        cartClaimWrapper.classList.remove('hidden');
        // Reinitialize the slider if it was hidden and is now shown
        if (cartClaimWrapper.classList.contains('hidden')) {
          this.initializeClaimVariants();
        }
      }
    }else{
      cartClaimWrapper.classList.add('hidden');
      this.slideElementsMap.forEach(async (value, key) => {
        document.querySelector(".cart-item[data-variant-id='"+key+"'] .CartItem__Remove").click()
      });
    }
  }

initializeClaimVariants() {
  // Destroy the existing Swiper instance if it exists
  if (this.swiperCartClaim) {
    this.swiperCartClaim.destroy(true, true);
    this.swiperCartClaim = null;
  }

  // Reinitialize the Swiper instance
  this.swiperCartClaim = new Swiper('.swiper-cart-claim', {
    loop: true,
    slidesPerView: 1.25,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    noSwipingSelector: '.cart-claim__button',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1200: {
        slidesPerView: 1.25,
        spaceBetween: 20,
        slidesOffsetBefore: 20,
      },
    },
  });

  // Add event listeners to the claim buttons
  document.querySelectorAll('.cart-claim__button').forEach(button => {
    // Remove existing event listeners if they exist
    if (button.dataset.listenerAdded) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      button = newButton;
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const slideElement = button.closest('.swiper-slide');
      const slideIndex = this.swiperCartClaim.slides.indexOf(slideElement);


      const productId = button.getAttribute('data-product-id');
      const productDataElement = document.querySelector(`.swiper-slide[data-product-id="${productId}"] .cart-item__media img`);
      let productData;

      // Log the data-product attribute to inspect its value
      const dataProduct = productDataElement.getAttribute('data-product');

      try {
        productData = JSON.parse(dataProduct);
      } catch (error) {
        console.error('Error parsing product data:', error);
        return;
      }

      const variantId = productData.variants.length > 1 ? null : productData.variants[0].id;

      if (variantId) {
        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";
        this.addProductToCart(variantId, slideElement);
      } else {
        this.activateVariantSelector(productId);
      }
    });

    // Mark the button as having a listener added
    button.dataset.listenerAdded = 'true';
  });
}

// ==========================================
// Cart Gift Methods
// ==========================================

initCartGift() {
  const wrapper = document.querySelector('.cart-gift__wrapper');
  if (!wrapper) return;

  const maxGifts = parseInt(wrapper.dataset.maxGifts) || 2;
  const addText = wrapper.dataset.addText || 'Add';
  const addedText = wrapper.dataset.addedText || 'Added';
  const cards = wrapper.querySelectorAll('.cart-gift__card');
  const removeAllBtn = wrapper.querySelector('.cart-gift__remove-all');

  // Sync state from cart — find items with _source: 'cart-gift'
  window.getCart().then(cartData => {
    const giftItems = cartData.items.filter(item => item.properties && item.properties._source === 'cart-gift');
    const giftVariantIds = giftItems.map(item => item.variant_id.toString());

    // Rebuild selections array from cart data, preserving FIFO order
    // Remove any selections not in cart anymore
    this.cartGiftSelections = this.cartGiftSelections.filter(id => giftVariantIds.includes(id.toString()));
    // Add any cart items not yet in selections
    giftVariantIds.forEach(id => {
      if (!this.cartGiftSelections.includes(id) && !this.cartGiftSelections.includes(Number(id))) {
        this.cartGiftSelections.push(id);
      }
    });

    // Update card UI states
    cards.forEach(card => {
      const variantId = card.dataset.variantId;
      const btn = card.querySelector('.cart-gift__card-btn');
      const btnText = btn.querySelector('.cart-gift__card-btn-text');
      const isInCart = giftVariantIds.includes(variantId.toString());

      if (isInCart) {
        btn.classList.add('cart-gift__card-btn--added');
        btnText.textContent = addedText;
      } else {
        btn.classList.remove('cart-gift__card-btn--added');
        btnText.textContent = addText;
      }
    });

    // REMOVE ALL button visibility
    if (this.cartGiftSelections.length >= maxGifts) {
      removeAllBtn.style.display = 'block';
    } else {
      removeAllBtn.style.display = 'none';
    }

    // Bind click events (clone to remove old listeners)
    cards.forEach(card => {
      const btn = card.querySelector('.cart-gift__card-btn');
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = newBtn.dataset.variantId;
        const isAdded = newBtn.classList.contains('cart-gift__card-btn--added');

        if (isAdded) {
          this.handleCartGiftRemove(variantId);
        } else {
          this.handleCartGiftAdd(variantId);
        }
      });
    });

    // REMOVE ALL click
    const newRemoveAllBtn = removeAllBtn.cloneNode(true);
    removeAllBtn.parentNode.replaceChild(newRemoveAllBtn, removeAllBtn);
    newRemoveAllBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleCartGiftRemoveAll();
    });
  });
}

async handleCartGiftAdd(variantId) {
  const wrapper = document.querySelector('.cart-gift__wrapper');
  if (!wrapper) return;

  const maxGifts = parseInt(wrapper.dataset.maxGifts) || 2;

  // Show loading
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    // If at max, remove the oldest selection first (FIFO)
    if (this.cartGiftSelections.length >= maxGifts) {
      const oldestVariantId = this.cartGiftSelections[0];
      // Find the cart item key for this variant
      const cartData = await window.getCart();
      const oldItem = cartData.items.find(item =>
        item.variant_id.toString() === oldestVariantId.toString() &&
        item.properties && item.properties._source === 'cart-gift'
      );
      if (oldItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldItem.key, quantity: 0 }),
        });
        this.cartGiftSelections.shift();
      }
    }

    // Add the new gift
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _source: 'cart-gift' },
      }),
    });

    this.cartGiftSelections.push(variantId.toString());
    this.renderContents();
  } catch (error) {
    console.error('Error adding cart gift:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

async handleCartGiftRemove(variantId) {
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    const cartData = await window.getCart();
    const giftItem = cartData.items.find(item =>
      item.variant_id.toString() === variantId.toString() &&
      item.properties && item.properties._source === 'cart-gift'
    );

    if (giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });

      this.cartGiftSelections = this.cartGiftSelections.filter(
        id => id.toString() !== variantId.toString()
      );
    }

    this.renderContents();
  } catch (error) {
    console.error('Error removing cart gift:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

async handleCartGiftRemoveAll() {
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    const cartData = await window.getCart();
    const giftItems = cartData.items.filter(item =>
      item.properties && item.properties._source === 'cart-gift'
    );

    // Remove all gift items sequentially
    for (const item of giftItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }

    this.cartGiftSelections = [];
    this.renderContents();
  } catch (error) {
    console.error('Error removing all cart gifts:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

addProductToCart(variantId, slideElement) {
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        _source: 'cart-claim',
      }
    }),
  })
  .then(response => response.json())
  .then(data => {
    // Save the slide BEFORE destroying the loop
    const slideHtml = slideElement.outerHTML;
    const slideIndex = Array.from(this.swiperCartClaim.slides)
      .filter(slide => !slide.classList.contains('swiper-slide-duplicate'))
      .indexOf(slideElement);

    // Store in map before any swiper modifications
    this.slideElementsMap.set(variantId, {
      html: slideHtml,
      index: slideIndex
    });

    // Now handle the Swiper updates
    this.swiperCartClaim.loopDestroy();
    this.swiperCartClaim.removeSlide(slideIndex);

    const uniqueSlides = Array.from(this.swiperCartClaim.slides)
      .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

    if (uniqueSlides.length > 1) {
      this.swiperCartClaim.loopCreate();
      this.swiperCartClaim.update();
      document.querySelector('.swiper-button-next').style.display = 'block';
      document.querySelector('.swiper-button-prev').style.display = 'block';
    } else {
      const duplicateSlides = this.swiperCartClaim.wrapperEl.querySelectorAll('.swiper-slide-duplicate');
      duplicateSlides.forEach(slide => slide.remove());
      this.swiperCartClaim.update();
      document.querySelector('.swiper-button-next').style.display = 'none';
      document.querySelector('.swiper-button-prev').style.display = 'none';
    }

    // Call these after the slide is properly stored
    this.renderContents();
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
}

  activateVariantSelector(productId) {
    const variantPicker = document.getElementById(`variant-picker-${productId}`);
    if (variantPicker) {
      variantPicker.classList.remove('hidden');
      variantPicker.classList.add('variant-picker__expanded');
    }
  }

  async handleRemoveCartClaim(itemKey, variantId) {
    try {
        const response = await fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // Add this to indicate AJAX request
            },
            body: JSON.stringify({
                id: itemKey,
                quantity: 0,
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // Ensure variantId is treated as a number
        const variantIdNum = Number(variantId);

        // Retrieve the slide element and its index from the Map
        let slideData;
        for (let [key, value] of this.slideElementsMap.entries()) {
            if (key === variantIdNum) {
                slideData = value;
                break;
            }
        }

        if (slideData) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = slideData.html;
            const slideElement = tempDiv.firstChild;

            // Check if a slide with the same data-variant-id already exists
            const existingSlide = this.swiperCartClaim.wrapperEl.querySelector(`[data-variant-id="${variantIdNum}"]`);
            if (!existingSlide) {
                // Use the index from the slideData object
                const insertPosition = slideData.index;

                // Get all slides including duplicates
                const allSlides = Array.from(this.swiperCartClaim.slides);

                // Calculate the correct position
                let correctPosition = insertPosition;
                allSlides.forEach((slide, index) => {
                    if (index < insertPosition && slide.classList.contains('swiper-slide-duplicate')) {
                        correctPosition--;
                    }
                });

                // Insert the slide at the correct position
                this.swiperCartClaim.addSlide(correctPosition, slideElement.outerHTML);
                this.swiperCartClaim.update();

                // Filter out duplicate slides
                const uniqueSlides = Array.from(this.swiperCartClaim.slides)
                    .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

                // Update navigation arrows visibility
                const navigationArrows = document.querySelectorAll('.swiper-button-next, .swiper-button-prev');
                if (uniqueSlides.length === 1) {
                    // Remove duplicate slides
                    const duplicateSlides = this.swiperCartClaim.wrapperEl.querySelectorAll('.swiper-slide-duplicate');
                    duplicateSlides.forEach(slide => slide.remove());
                    this.swiperCartClaim.update();
                    navigationArrows.forEach(arrow => arrow.style.display = 'none');
                } else {
                    this.swiperCartClaim.update();
                    navigationArrows.forEach(arrow => arrow.style.display = 'block');
                }
            }

            // Remove the entry from slideElementsMap
            const deleteSuccess = this.slideElementsMap.delete(variantIdNum);
            console.log('Delete operation successful:', deleteSuccess);
        }

        await this.validateSlides();
    } catch (error) {
        console.error('Error removing cart claim item:', error);
    }
  }

  async renderContents(fromElement = '', force,newVariantId,replaceItemKey) {
    if (this.isRendering && !force) return;
    this.forceRender = false;
    this.isRendering = true;

    var cartObj = this;
    var totalSavings = 0;

    try {
        // Show loading overlay
        const overlay = document.querySelector('.mini-cart-overlay');
        overlay.style.opacity = "1";
        overlay.style.pointerEvents = "auto";

        // Execute initial operations in parallel
        await Promise.all([
            window.pmoBuyXgetY(),
            this.validateGWPProducts(),
            window.updateCartTotalUSD()
        ]);

        await window.promotionValidate().then(async function() {
            await window.getCart().then(async function(response) {
                localStorage.setItem('cart_json', JSON.stringify(response));

                // Helper function to format monetary amounts consistently
                const formatAmount = (amount) => {
                  const roundedAmount = Math.floor(amount/100) * 100;
                  return formatMoney(roundedAmount).replace(/\.\d+/, '');
                };
                const exchangeRate = parseFloat(window.Shopify.currency.rate);
                

                if(response) {
                    const reducer = (a, b) => a + b;
                    let cartData = response;

                    // Nosto re-generate cart tagging after add item to cart
                    if(cartData){
                        var line_items = '';
                        var restore_link = '<span class="restore_link">'+window.location.origin+'/cart/';
                        const item_length = cartData.items.length;
                        if(cartData.items.length > 0){
                            cartData.items.forEach((item,i) => {
                                line_items += `<div class="line_item"><span class="product_id">${item.product_id}</span><span class="sku_id">${item.sku}</span><span class="quantity">${item.quantity}</span><span class="name">${item.title}</span><span class="unit_price">${formatMoney(item.price)}</span><span class="price_currency_code">${cartData.currency}</span></div>`;
                                restore_link += item.variant_id+':'+item.quantity;
                                if((i+1) < item_length){
                                    restore_link += ',';
                                }
                            });
                            restore_link += '</span>';
                            line_items += restore_link;
                        } else {
                            line_items = '';
                        }

                        document.querySelectorAll('.nosto_cart').forEach(function(element){
                            element.innerHTML = line_items;
                        });


                      // update Recommendations

                      if(document.querySelector(".nosto_element.nosto_element__sidebar")){
                        fetch("/?section_id=cust-cart-notification")
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          document.querySelector(".nosto_element.nosto_element__sidebar").innerHTML = html.querySelector(".nosto_element.nosto_element__sidebar").innerHTML
                          cartObj.initRecommendations();
                        });
                      }
                    }

                    // Cache frequently accessed DOM elements
                    const elements = {
                        cartMessage: document.querySelector(".cart-save-message.cart-save-message--progress"),
                        emptyCartShipping: document.querySelector(".cart-items__empty .cart-save-message li:nth-child(1)"),
                        emptyCartGift: document.querySelector(".cart-items__empty .cart-save-message li:nth-child(2)"),
                        emptyCartGift2: document.querySelector(".cart-items__empty .cart-save-message li:nth-child(3)"),
                        cartCountBubble: document.querySelector('.cart-count-bubble--value'),
                        cartCountBubbleWithLabel: document.querySelector('.cart-count-bubble-with-label--value'),
                        cartItemCount: document.querySelector('[data-cart-item-count]'),
                        progressBar: document.querySelector('.progress-bar'),
                        progressBarWrap: document.querySelector('.progress-bar-wrap'),
                        cartNotificationDrawer: document.querySelector('.cart-notification__drawer'),
                        cartForm: document.querySelector('.cart-form'),
                        cartItemsEmpty: document.querySelector('.cart-items__empty'),
                        cartFooterMain: document.querySelector('.cart-notification__footer.footer__main'),
                        cartItems: document.getElementById('cart-items')
                    };

                    // Your existing variable declarations
                    var barRemainingAmount = 0,
                    cartMessage = document.querySelector(".cart-save-message.cart-save-message--progress"),
                    emptyCartShipping = document.querySelector(".cart-items__empty .cart-save-message li:nth-child(1)"),
                    emptyCartGift = document.querySelector(".cart-items__empty .cart-save-message li:nth-child(2)"),
                    emptyCartGift2 = document.querySelector(".cart-items__empty .cart-save-message li:nth-child(3)"),
                    promotion1 =  window.promotionSettings.gwp[0],
                    promotion1Price = (promotion1.minimumCartAmount * 100),
                    promotion1Indicator = window.freeShipping.shipping[0].gift1Indicator,
                    promotion2Indicator = window.freeShipping.shipping[0].gift2Indicator,
                    promotion2 =  window.promotionSettings.gwp[1],
                    promotion2Price = (promotion2.minimumCartAmount * 100),
                    freeShipping = window.freeShipping.shipping[0],
                    freeShippingPrice = (freeShipping.threshold * 100),
                    freeShippingIsCustom = freeShipping.is_custom,
                    freeClaimPrice = (freeShipping.freeClaimThreshold * 100),
                    protectionAdj = getProtectionCartAdjustments(cartData),
                    cartTotal = cartData.total_price - protectionAdj.protectionCents,
                    cartTotalGift = cartData.total_price - protectionAdj.protectionCents,
                    itemCounts = Math.max(0, cartData.item_count - protectionAdj.protectionQty),
                    giftInventory1 = promotion1.giftInventory,
                    minimumGiftQuantity1 = promotion1.minimumGiftQuantity,
                    giftInventory2 = promotion2.giftInventory,
                    minimumGiftQuantity2 = promotion2.minimumGiftQuantity;
                    const cartCountBubble = document.querySelector('.cart-count-bubble--value')
                    const cartCountBubbleWithLabel = document.querySelector('.cart-count-bubble-with-label--value')
                    const enableCartGift = freeShipping.enableCartGift;

                    var excludeSellingPlanNames = window.pmoBuyXgetYSettings.excludeSellingPlanNames?window.pmoBuyXgetYSettings.excludeSellingPlanNames.split(","):[];
                    if(excludeSellingPlanNames.length > 0){
                      excludeSellingPlanNames.forEach(selling_item => {
                        cartData.items.forEach(item => {
                          if(item.selling_plan && item.selling_plan.name.includes(selling_item)){
                            const skipProtection =
                              window.protectionProductId != null &&
                              window.protectionProductId !== '' &&
                              item.product_id != null &&
                              String(item.product_id) === String(window.protectionProductId);
                            if (!skipProtection) {
                              cartTotalGift = cartTotalGift - item.line_price
                            }
                          }
                        })
                      })
                    }

                    // Update header cart count bubble value
                    cartCountBubble.innerHTML = itemCounts
                    cartCountBubbleWithLabel.innerHTML = itemCounts > 1 ? itemCounts + ' items' : itemCounts + ' item'
                    document.querySelector('[data-cart-item-count]').innerHTML = itemCounts

                const $cartLargestThreshold = cartObj.cartLargestThreshold;

                let freeShippingPriceFlag = false;
                if(freeShippingPrice) {
                  freeShippingPriceFlag = true;
                } else {
                  if (freeShippingPrice === 0){
                    freeShippingPriceFlag = true;
                  }
                }

                  // Display logic for cart-save-message and progress bars
              const display = itemCounts > 0 ? 'block' : 'none';
              document.querySelector('.cart-save-message--progress').style.display = display;
              document.querySelector('.progress-bar-wrap').style.display = display;


              // Helper function to format monetary amounts consistently
              const formatAmount = (amount) => {
                const roundedAmount = Math.floor(amount/100) * 100;
                return formatMoney(roundedAmount).replace(/\.\d+/, '');
              };

              // Convert promotion prices from USD cents to local currency cents

              // Since promotion prices are in cents, we first convert to dollars, then multiply by exchange rate, then back to cents
              const promotion1PriceLocal = (promotion1Price / 100) * exchangeRate * 100;
              const promotion2PriceLocal = (promotion2Price / 100) * exchangeRate * 100;
              let freeShippingPriceLocal = (freeShippingPrice / 100) *  exchangeRate * 100;
              if(freeShippingIsCustom){
                freeShippingPriceLocal = (freeShippingPrice / 100) *  1 * 100;
              }
              const freeClaimPriceLocal = (freeClaimPrice / 100) *  exchangeRate * 100;
              
              if(!document.querySelector('.progress-bar-wrap').classList.contains("static")){
              document.querySelector('.progress-bar').style.display = display;

                let shippingMessage = "";
                let giftMessage = "";
                let eligibleForPromotion1 = false;
                let eligibleForPromotion2 = false;
                let shippingBarCalc = 0;

                // Multi-GWP mode: use cartGiftProgressInfo + cartGiftMinimumAmountLocal

                if (enableCartGift) {
                  // --- Multi-GWP gift message ---
                  const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
                    ? (freeShipping.cartGiftMinimumAmountLocal * 100)
                    : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;

                  if (cartTotal < cartGiftMinAmountLocal) {
                    const barRemainingAmount = cartGiftMinAmountLocal - cartTotal;
                    giftMessage = freeShipping.cartGiftProgressInfo.replace(
                      "[amount_gift]",
                      `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                    );
                  } else {
                    giftMessage = freeShipping.cartGiftProgressInfoQualified || "You've got some free gifts!";
                  }

                  // --- Shipping message (same as before) ---
                  if (freeShippingPriceFlag) {
                    if (cartTotal < freeShippingPriceLocal) {
                      const barRemainingAmount = freeShippingPriceLocal - cartTotal;
                      shippingMessage = freeShipping.freeShippingNotquali.replace(
                        "[amount_shipping]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else {
                      shippingMessage = freeShipping.freeShippingQuali;
                    }
                  }

                  // --- Progress bar indicator ---
                  if(itemCounts <= 0) {
                    if (document.querySelector('.indicator')) {
                      document.querySelector('.indicator').style.transform = 'scale(0, 1)';
                    }
                  } else {
                    let targetThreshold;
                    if (cartTotal < freeShippingPriceLocal) {
                      targetThreshold = freeShippingPriceLocal;
                    } else if (cartTotal < cartGiftMinAmountLocal) {
                      targetThreshold = cartGiftMinAmountLocal;
                    } else {
                      targetThreshold = cartGiftMinAmountLocal; // fully met
                    }

                    if (targetThreshold === 0) {
                      shippingBarCalc = 1;
                    } else {
                      shippingBarCalc = parseFloat(cartTotal / targetThreshold);
                    }
                    if (shippingBarCalc > 1) {
                      shippingBarCalc = 1;
                    }
                    if (document.querySelector('.indicator')) {
                      document.querySelector('.indicator').style.transform = 'scale(' + shippingBarCalc + ', 1)';
                    }
                  }

                } else {
                  // --- Old GWP logic (unchanged) ---

                  // Check if cart qualifies for the first promotion
                  if (promotion1.enable && promotion1Indicator == 'true') {
                    if (cartTotalGift < promotion1PriceLocal && giftInventory1 > minimumGiftQuantity1) {
                      eligibleForPromotion1 = true;
                      const barRemainingAmount = promotion1PriceLocal - cartTotalGift;
                      giftMessage = freeShipping.gift1Notquali.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else if (cartTotalGift >= promotion1PriceLocal) {
                      eligibleForPromotion1 = false;
                    }
                  }

                  // Check if cart qualifies for the second promotion
                  if (promotion2.enable && promotion2Indicator == 'true' && cartTotalGift >= promotion1PriceLocal) {
                    if (cartTotalGift < promotion2PriceLocal) {
                      eligibleForPromotion2 = true;
                      const barRemainingAmount = promotion2PriceLocal - cartTotalGift;
                      giftMessage = freeShipping.gift2Notquali.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else {
                      eligibleForPromotion2 = false;
                    }
                  }

                  // Build free shipping message
                  if (freeShippingPriceFlag) {
                    if (cartTotal < freeShippingPriceLocal) {
                      const barRemainingAmount = freeShippingPriceLocal - cartTotal;
                      shippingMessage = freeShipping.freeShippingNotquali.replace(
                        "[amount_shipping]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else {
                      shippingMessage = freeShipping.freeShippingQuali;
                    }
                  }

                  if(itemCounts <= 0) {
                    if (document.querySelector('.indicator')) {
                      document.querySelector('.indicator').style.transform = 'scale(0, 1)';
                    }
                  } else {
                    let targetThreshold;

                    if(eligibleForPromotion1 && eligibleForPromotion2) {
                      targetThreshold = giftInventory1 >= minimumGiftQuantity1 ? promotion2PriceLocal : freeShippingPriceLocal;
                    } else if (eligibleForPromotion1 && !eligibleForPromotion2) {
                      targetThreshold = giftInventory1 >= minimumGiftQuantity1 ? promotion1PriceLocal : freeShippingPriceLocal;
                    } else if (!eligibleForPromotion1 && eligibleForPromotion2) {
                      targetThreshold = giftInventory2 >= minimumGiftQuantity2 ? promotion2PriceLocal : freeShippingPriceLocal;
                    } else {
                      targetThreshold = freeShippingPriceLocal;
                    }

                    if (targetThreshold === 0) {
                      shippingBarCalc = 1;
                    } else {
                      shippingBarCalc = parseFloat(cartTotal/targetThreshold);
                    }

                    if(shippingBarCalc > 1){
                      shippingBarCalc = 1;
                    }
                    if (document.querySelector('.indicator')) {
                      document.querySelector('.indicator').style.transform = 'scale('+shippingBarCalc+', 1)';
                    }
                  }

                  // Override gift message if above free shipping threshold (promotion priority)
                  if (cartTotalGift >= freeShippingPriceLocal) {
                    if (eligibleForPromotion1) {
                      const barRemainingAmount = promotion1PriceLocal - cartTotalGift;
                      giftMessage = freeShipping.gift1Notquali.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else if (!eligibleForPromotion1 && eligibleForPromotion2) {
                      const barRemainingAmount = promotion2PriceLocal - cartTotalGift;
                      giftMessage = freeShipping.gift2Notquali.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
                      );
                    } else if (cartTotalGift >= promotion2PriceLocal && promotion2.enable && promotion2Indicator == 'true') {
                      giftMessage = freeShipping.giftFs12Quali || "";
                    } else if (cartTotalGift >= promotion1PriceLocal && !promotion2.enable && promotion1.enable && promotion1Indicator == 'true') {
                      giftMessage = freeShipping.giftFs12Quali || "";
                    } else {
                      giftMessage = "";
                    }
                  }
                }

                // Combine shipping + gift messages into one element
                let combinedMessage = "";
                if (shippingMessage) {
                  combinedMessage += `<span class="cart-save-message__shipping">${shippingMessage}</span>`;
                }
                if (giftMessage) {
                  combinedMessage += ` <span class="cart-save-message__gift">${giftMessage}</span>`;
                }

                cartMessage.innerHTML = combinedMessage;

              const shippingBadgeDisplay = (cartTotal > 0 && cartTotal >= freeShippingPriceLocal) ? 'flex' : 'none';
              if (document.querySelector('.progress__badge.progress__badge--shipping')) {
                document.querySelector('.progress__badge.progress__badge--shipping').style.display = shippingBadgeDisplay;
              }

              if (!enableCartGift) {
                const giftBadgeDisplay = (promotion1.enable && promotion1Indicator == 'true' && cartTotalGift > 0 && cartTotalGift > promotion1PriceLocal) ? 'flex' : 'none';
                if (document.querySelector('.progress__badge.progress__badge--gift')) {
                  document.querySelector('.progress__badge.progress__badge--gift').style.display = giftBadgeDisplay;
                }

                const gift2BadgeDisplay = (promotion2.enable && promotion2Indicator == 'true' && cartTotalGift > 0 && cartTotalGift > promotion2PriceLocal) ? 'flex' : 'none';
                if (document.querySelector('.progress__badge.progress__badge--gift-2')) {
                  document.querySelector('.progress__badge.progress__badge--gift-2').style.display = gift2BadgeDisplay;
                }
              } else {
                // Multi-GWP: display gift badge only if a gift is selected
                const hasCartGift = cartData.cartJson.items.some(item => item.properties && item.properties._source === 'cart-gift');
                const giftBadgeDisplay = hasCartGift ? 'flex' : 'none';
                
                if (document.querySelector('.progress__badge.progress__badge--gift')) {
                  document.querySelector('.progress__badge.progress__badge--gift').style.display = giftBadgeDisplay;
                }
                if (document.querySelector('.progress__badge.progress__badge--gift-2')) {
                  document.querySelector('.progress__badge.progress__badge--gift-2').style.display = 'none';
                }
              }
            }
              // .sort((a, b) => {
              //             // Check if either item is a GWP and prioritize it
              //             const isAGWP = a.product_type.toLowerCase() === "gwp";
              //             const isBGWP = b.product_type.toLowerCase() === "gwp";
              //             return isAGWP === isBGWP ? 0 : isAGWP ? -1 : 1;
              //           })

                // Append items
                if(itemCounts > 0) {
                  document.querySelector('.cart-notification__count').style.display = 'inline-block';
                  if(itemCounts == 1){
                    document.querySelector('.cart-notification__count .item-count__1').style.display = 'none';
                  } else {
                    document.querySelector('.cart-notification__count .item-count__1').style.display = 'inline-block';
                  }
                  if(document.querySelector('.nosto__heading')){
                    document.querySelector('.nosto__heading').innerHTML = 'Pairs Well With';
                  }
                  document.querySelector('.cart-notification__drawer').classList.remove('cart__empty');
                  document.querySelector('.cart-form').classList.remove('cart-form__empty');
                  document.querySelector('.cart-items__empty').style.display = "none";
                  document.querySelector('.cart-notification__footer.footer__main').classList.remove('hidden')
                  document.querySelector('.cart-notification__footer').classList.remove('hidden')
                  if(document.getElementById('cart-items').classList.contains('hidden')) document.getElementById('cart-items').classList.remove('hidden')
                  if(document.querySelector('.cart-gift__wrapper')){
                    if (enableCartGift) {
                      // Multi-GWP: conditional button disable
                      const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
                        ? (freeShipping.cartGiftMinimumAmountLocal * 100)
                        : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;
                        
                      document.querySelector('.cart-gift__wrapper').classList.remove('hidden');
                      
                      const giftBtns = document.querySelectorAll('.cart-gift__card-btn');
                      if (cartTotal >= cartGiftMinAmountLocal) {
                        giftBtns.forEach(btn => btn.removeAttribute('disabled'));
                      } else {
                        giftBtns.forEach(btn => btn.setAttribute('disabled', 'disabled'));
                      }
                    } else {
                      document.querySelector('.cart-gift__wrapper').classList.remove('hidden');
                    }
                  }
                  // document.getElementById('cart-items').innerHTML = cartItemTemplate
                  const cart_items = document.getElementById('cart-items');

                  cart_items.querySelectorAll(".cart-item__block").forEach(temp => temp.classList.add("removed"))
                cartData.cartJson.items.map((item, index) => {
                  if (
                    window.protectionProductId != null &&
                    window.protectionProductId !== '' &&
                    item.product_id != null &&
                    String(item.product_id) === String(window.protectionProductId)
                  ) {
                    return;
                  }
                  let variants = [];
                  let colorVariants = false;
                  let hasVariantSelector = false;
                  let hasItemOption = false;

                  const cartNotification = document.querySelector("cart-notification");
                  item.options_with_values.forEach(option => {
                    if (cartNotification.mulVariantOptions.includes(option.name)) {
                      colorVariants = true;
                    }
                    if (option.name === 'Item' || option.name === 'Size' || option.name === 'Select Your Set') {
                      hasItemOption = false;
                    }
                  });

                  const cartItem = cartData.items.find(cartItem => cartItem.key === item.key);
                  if (cartItem) {
                    variants = cartItem.product_variants
                    if (cartItem.product_variants.length > 1) {
                      hasVariantSelector = true;
                    }
                  }

                  let removeButton;
                  let compareAtPriceValue = ''
                  if(cartItem.compare_at_price > 0){
                    compareAtPriceValue = formatMoney(cartItem.compare_at_price)
                  }
                  const compareAtPrice = cartData.items.filter(cartJsonItem => {
                    if(cartJsonItem.id == item.id) {
                  const compare_at_price = cartJsonItem.compare_at_price
                  if(compare_at_price != null) {
                    totalSavings = totalSavings + (compare_at_price - cartJsonItem.original_price) * cartJsonItem.quantity;
                    // compareAtPriceValue = formatMoney(compare_at_price)
                  } else {
                    // compareAtPriceValue = '';
                  }
                    }
                  })

                  var quantityBox = '', productPrice = 0, productTitle = "",
                  isFreeGift = (item.properties && item.properties.free_gift) ? item.properties.free_gift : false,
                  isCartClaim = (item.properties && item.properties._source === 'cart-claim'),
                  isCartGift = (item.properties && item.properties._source === 'cart-gift');

                  const productType = (item.product_type || '').toLowerCase();
                  const isGwp = productType === 'gwp';
                  const isGiftLikeItem = isGwp || isFreeGift || isCartGift;
                  const canEditQuantity = !isGiftLikeItem;

                  removeButton = isCartClaim ? `
                  <a href="#" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item-claim">REMOVE</a>
                ` : (!isFreeGift ? `
                  <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                ` : '');

                  if (canEditQuantity) {
                    quantityBox = `<div class="cart-item__quantity">
                      <div class="cart-item__quantity-wrapper">
                        <quantity-input class="quantity">
                          <button class="quantity__button no-js-hidden" name="minus" type="button">
                            <span class="visually-hidden">decrease ${ item.title }</span>
                            <svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2">
                              <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                            </svg>
                          </button>
                          <input class="quantity__input"
                            type="number"
                            name="updates[]"
                            variant-id="${item.variant_id}"
                            value="${ item.quantity }"
                            min="0"
                            aria-label="${ item.title }"
                            id="Quantity-${ index + 1 }"
                            data-index="${ index + 1 }"
                          >
                          <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">increase ${ item.title }</span>
                            <svg class="Icon Icon--plus " role="presentation" viewBox="0 0 16 16">
                              <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                <path d="M8,1 L8,15"></path>
                                <path d="M1,8 L15,8"></path>
                              </g>
                            </svg>
                          </button>
                        </quantity-input>
                      </div>
                    </div>`;

                    productPrice = formatMoney(item.price);
                    if(item.discounts.length){
                      compareAtPriceValue = formatMoney(item.original_price);
                      productPrice = formatMoney(item.line_price/item.quantity);
                    }
                    if(compareAtPriceValue.includes('.00')){
                      compareAtPriceValue = compareAtPriceValue.replace('.00', '');
                    }

                    if(productPrice.includes('.00')){
                      productPrice = productPrice.replace('.00', '');
                    }

                    const variantOptions = item.variant_options.map(option => {
                      return '<p class="cart-item__property">' + option.split("__")[0] + '</p>';
                      }).join('');

                      if (productType === 'gwp' || productType === 'upsell') {
                        // For GWP items - no link
                        if (!variantOptions.toLowerCase().includes('title')) {
                          productTitle = `<span class="cart-item__name h4 break">${item.product_title}${variantOptions}</span>`;
                        } else {
                          productTitle = `<span class="cart-item__name h4 break">${item.product_title}</span>`;
                        }
                      } else {
                        // For non-GWP items - include link
                        if (!variantOptions.toLowerCase().includes('title')) {
                          productTitle = `<a href="${item.url}" class="cart-item__name h4 break">${item.product_title}${variantOptions}</a>`;
                        } else {
                          productTitle = `<a href="${item.url}" class="cart-item__name h4 break">${item.product_title}</a>`;
                        }
                      }

                  } else {
                    quantityBox = `<div class="CartItem__Actions">
                    <span>Qty: 1</span>
                  </div>`;
                    // format price if greater than 0 and the item is a free gift
                    if((isFreeGift || isCartClaim) && item.price > 0){
                      productPrice = formatMoney(item.price);
                      if(productPrice.includes('.00')){
                        productPrice = productPrice.replace('.00', '');
                      }
                    }else{
                      productPrice = "Free";
                    }

                    const variantOptions = item.variant_options.map(option => {
                      return '<p class="cart-item__property">' + option.split("__")[0] + '</p>';
                      }).join('');

                      if (!variantOptions.toLowerCase().includes('title')) {
                        productTitle = '<span class="cart-item__name h4 break">' + item.product_title + variantOptions + '</span>';
                    } else {
                      productTitle = '<span class="cart-item__name h4 break">' + item.product_title + '</span>';
                    }

                  }
                  if(item.vendor == "Rise.ai") {
                    quantityBox = '<div class="CartItem__Actions"><span>Qty: '+item.quantity+'</span><a href="/cart/change?quantity=0&amp;id='+item.key+'" class="CartItem__Remove link--text block text-sm mt-2" data-quantity="0" data-line-id="'+item.key+'" data-item-id="'+item.id+'"data-action="remove-item">Remove</a></div>';
                  }

                  const item_block = cart_items.querySelector(".cart-item__block[data-line-item-key='" + item.key+"']");
                  const rechargeEnable = cartNotification.dataset.rechargeEnable ? true: false;
                  const block_html =  `
                    <div class="cart-item" data-variant-id="${item.variant_id}">
                      <div class="cart-item__media">
                        <img class="cart-item__image trynow_item_image"
                          src="${ item.featured_image.url }"
                          loading="lazy"
                          width="240"
                          height="240"
                        >
                      </div>
                      <div class="cart-item__right">
                        <div class="cart-item__details">
                          ${ productTitle }
                          ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' }
                          ${ quantityBox }
                        </div>
                      </div>

                      <div class="cart-item__options">
                        <div class="cart-item__price js-is-this">
                          <span class="cart-item__price-compare">${ productPrice }</span>
                          ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                        </div>

                        ${ (item.product_type.toLowerCase() != "gwp" || isCartClaim) ? `
                          <div class="cart-item__update">
                        ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                        ${ removeButton }
                          </div>
                        ` : '' }
                      </div>
                    </div>
                    ${(rechargeEnable&&(item.product_id != 4516431593533)) ? `<cart-subscription class="cart-item__inner-subscription hidden" data-recharge-subscription-text="${ cartNotification.dataset.rechargeSubscriptionText }" data-recharge-subscription-save-label="${ cartNotification.dataset.rechargeSubscriptionSaveLabel }" data-product-id="${ item.product_id }" data-selling-plan-id="${ item.selling_plan_allocation?item.selling_plan_allocation.selling_plan.id:'' }">
                      <div class="cart-item__inner-subscription-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M9.24763 6.43702C9.17303 6.22724 9.03543 6.04564 8.85365 5.91707C8.67187 5.78851 8.45481 5.71926 8.23216 5.7188H7.39855C7.16072 5.71756 6.93089 5.80454 6.75348 5.96294C6.57608 6.12133 6.4637 6.33988 6.4381 6.57632C6.41249 6.81276 6.47546 7.0503 6.61484 7.24301C6.75422 7.43571 6.96011 7.56988 7.19268 7.61958L8.46202 7.89653C8.72157 7.95335 8.95097 8.10408 9.10614 8.31976C9.26131 8.53544 9.3313 8.80085 9.30268 9.065C9.27405 9.32915 9.14883 9.5734 8.95106 9.75083C8.75329 9.92826 8.49693 10.0264 8.23123 10.0263H7.51394C7.04498 10.0263 6.64617 9.72715 6.49847 9.30896M7.87305 5.7188V4.64148M7.87305 11.1036V10.0272M3.38281 13.9995V11.6916H5.69071" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.8971 6.89585C14.1422 8.20231 13.9465 9.55318 13.3409 10.7364C12.7352 11.9196 11.7537 12.8683 10.5506 13.4334C9.34744 13.9985 7.99071 14.1482 6.69333 13.8588C5.39596 13.5695 4.23137 12.8575 3.38237 11.8347M2.10288 9.10404C1.8578 7.79758 2.05347 6.44672 2.65916 5.26349C3.26486 4.08025 4.24629 3.13163 5.44943 2.5665C6.65257 2.00137 8.0093 1.85174 9.30668 2.14108C10.6041 2.43042 11.7686 3.14236 12.6176 4.16515" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.6175 2.00122V4.30911H10.3096" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </div>
                      <div class="cart-item__inner-subscription-text">
                          <div class="cart-item__inner-subscription-default">
                          </div>
                          <div class="cart-item__inner-subscription-select" >
                              <select class="cart-item__inner-subscription-select-sel">
                                  <optgroup label="Pay Full Price">
                                  <option value="">One-time only</option>
                                  </optgroup>

                              </select>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M8 10L12.2 14.2L16.4 10" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </div>
                      </div>
                  </cart-subscription>`: ''}
                    `
                    // colorVariants && hasItemOption == false &&
                  const script_html = `<div class="cart-item__variant-picker one-time">
                    <div class="variant-picker__content">
                      <div class="cart-notification__header">
                        <h2 class="cart-notification__heading caption-large text-body">Select Shade</h2>
                        <button type="button" class="variant-picker__close link link--text focus-inset">
                          <img src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/close.svg?v=1725933626" width="24" height="24">
                        </button>
                      </div>
                     <div class="cart-item" data-variant-id="${item.variant_id}">
                        <div class="cart-item__media">
                          <img class="cart-item__image"
                            src="${ item.featured_image.url }"
                            loading="lazy"
                            width="240"
                            height="240"
                          >
                        </div>
                        <div class="cart-item__right">
                          <div class="cart-item__details">
                            ${ productTitle }
                            ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' }
                            ${ quantityBox }
                          </div>
                        </div>

                        <div class="cart-item__options">
                          <div class="cart-item__price">
                            <span class="cart-item__price-compare">${ productPrice }</span>
                            ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                          </div>

                          ${ item.product_type.toLowerCase() != "gwp" ? `
                            <div class="cart-item__update">
                          ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                              <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                            </div>
                          ` : '' }
                       </div>
                      </div>
                      <variant-radios class="no-js-hidden swatch_round" data-section data-url="/products/${item.handle}">
                            <div class="cart-item__active-variant">
                              <div class="active-variant__content">
                              ${(() => {
                                const matchedVariant = variants.find(variant => variant.id === item.id);
                                const swatchColor = matchedVariant ? matchedVariant.metafields.swatch_color : 'transparent';
                                const variantTitle = matchedVariant ? matchedVariant.name : 'Unknown Variant';

                                const swatchFile = matchedVariant ? matchedVariant.metafields.swatch_img: '';
                                if(swatchFile && (!swatchColor || swatchColor == 'transparent')){
                                   return `
                                    <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;">
                                      <img src="${ swatchFile }" loading="lazy" width="58" height="58">
                                    </span>
                                    <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                                  `;
                                }
                                return `
                                  <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;"></span>
                                  <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                                `;
                              })()}
                              </div>
                              <img class="active-variant__close inverted" src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/arrow-down.svg?v=1725933654" height="24" width="24">
                            </div>
                          <div class="active-variant__drawer">

                          </div>
                          <script-element type="application/json">
                            ${JSON.stringify(variants)}
                          </script-element>
                      </variant-radios>
                      <div class="cart-notification__footer footer__static ">
                        <div class="cart_drawer_formBox">
                        ${(() => {
                                const matchedVariant = variants.find(variant => variant.id === item.id);
                                const safeIndex = Math.max(index - 1, 0);
                                return `
                          <button type="button" class="button btn variant-update__btn" data-variant-id="${item.id}" data-line-item-key="${item.key}" data-line-item-index="${ safeIndex }" data-quantity="${ item.quantity }">
                            <span class="btn__text button--full-width">Update</span>
                          </button>
                                `;
                              })()}

                        </div>
                      </div>
                    </div>
                  </div>`
                  if(!item_block){
                    const fragment = document.createDocumentFragment();
                    const block = document.createElement('div');
                    block.className = 'cart-item__block' + (isCartGift ? ' cart-item--cart-gift' : '');
                    block.setAttribute('data-variant-id', item.variant_id);
                    block.setAttribute('data-line-item-key', item.key);
                    block.innerHTML = block_html
                    const script = document.createElement('script');
                    script.type = 'application/x-template';
                    script.setAttribute('data-line-item-variant-picker', item.key || '');
                    script.textContent = script_html;
                    fragment.appendChild(block);
                    fragment.appendChild(script);
                    if(newVariantId && replaceItemKey && newVariantId == item.variant_id){
                      const oldItem = cart_items.querySelector(".cart-item__block[data-line-item-key='" + replaceItemKey+"']")
                      if (oldItem) {
                        cart_items.insertBefore(fragment, oldItem);
                      }
                    }else{
                      cart_items.append(fragment)
                    }
                  }else{
                    item_block.classList.remove("removed");
                    item_block.querySelector(".cart-item__details").innerHTML = `${ productTitle } ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' } ${ quantityBox }`
                    item_block.querySelector(".cart-item__options").innerHTML = `<div class="cart-item__price">
                            <span class="cart-item__price-compare">${ productPrice }</span>
                            ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                          </div>

                          ${ item.product_type.toLowerCase() != "gwp" ? `
                            <div class="cart-item__update">
                          ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                              <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                            </div>
                          ` : '' }`
                  }
                })

                  cart_items.querySelectorAll(".cart-item__block.removed").forEach(temp => temp.remove());

                  // Update Sub Total, Savings, & Cart Item Count
                  document.querySelectorAll('.button__price').forEach(buttonPriceElement => {
                    if (!buttonPriceElement.classList.contains('nosto-price')) {
                      buttonPriceElement.innerHTML = formatMoney(cartData.total_price);
                    }
                  });
                  if(document.querySelector('[data-order-rewards-points]')){
                    document.querySelector('[data-order-rewards-points]').innerHTML = window.cartTotalUSD;
                  }
                  document.querySelector('[data-cart-item-count]').innerHTML = itemCounts

                  const cartClaimWrapper = document.querySelector('.cart-claim__wrapper');
                  if(cartClaimWrapper){
                    const swiperWrapper = cartClaimWrapper.querySelector('.swiper-wrapper');
                    const slides = swiperWrapper.querySelectorAll('.swiper-slide');

                    // Calculate claimedCount
                    const claimLimit = window.claimLimit; // Get the claim limit from the global variable
                    const claimedCount = cartObj.slideElementsMap.size;
                    console.log(freeClaimPriceLocal,cartTotal)
                    // Check if there are slides and if the claimed count exceeds the claim limit
                    if(cartTotal > freeClaimPriceLocal){
                      if (slides.length > 0 && claimedCount < claimLimit) {
                        cartObj.initializeClaimVariants();
                        cartClaimWrapper.classList.remove('hidden');
                      } else {
                        cartClaimWrapper.classList.add('hidden');
                      }
                    }else{
                      cartClaimWrapper.classList.add('hidden');
                      for (const [key, value] of cartObj.slideElementsMap) {
                        const removeVariantEle = document.querySelector(".cart-item[data-variant-id='"+key+"']");
                        const removeBtn = removeVariantEle.querySelector(".CartItem__Remove");
                        await cartObj.handleRemoveCartClaim(removeBtn.dataset.lineId, key);
                        cartObj.forceRender = true;
                      }
                    }
                  }

                } else {
                  // Reinsert slides back into the slider before clearing the slideElementsMap
                  cartObj.slideElementsMap.forEach((value, key) => {
                    const slideElement = document.createElement('div');
                    slideElement.classList.add('swiper-slide');
                    slideElement.innerHTML = value.html;
                    cartObj.swiperCartClaim.appendSlide(slideElement);
                    cartObj.swiperCartClaim.update();

                  // Show navigation arrows if there are multiple unique slides
                  document.querySelector('.swiper-button-next').style.display = 'block';
                  document.querySelector('.swiper-button-prev').style.display = 'block';
                  });

                  // Clear the slideElementsMap
                  cartObj.slideElementsMap.clear();

                  if(document.querySelector('.nosto__heading')){
                    document.querySelector('.nosto__heading').innerHTML = 'Recommended Products';
                  }

                  document.querySelector('.cart-notification__count').style.display = 'none';
                  if(document.querySelector('.cart-claim__wrapper')){
                    document.querySelector('.cart-claim__wrapper').classList.add('hidden')
                  }
                  if(document.querySelector('.cart-gift__wrapper')){
                    document.querySelector('.cart-gift__wrapper').classList.add('hidden');
                  }

                  localStorage.removeItem('totalSavingsValue')
                  document.querySelector('.progress-bar-wrap').style.display = 'none';
                  document.querySelector('.cart-notification__drawer').classList.add('cart__empty');
                  document.querySelector('.cart-form').classList.add('cart-form__empty');

                  if(emptyCartShipping) {
                    // Convert free shipping threshold to local currency
                    const freeShippingLocal = (freeShippingPrice / 100) * exchangeRate * 100;

                    if (cartTotal >= freeShippingLocal) {
                      emptyCartShipping.innerHTML = freeShipping.freeShippingQuali;
                    } else {
                      emptyCartShipping.innerHTML = freeShipping.freeShippingNotquali.replace(
                        "[amount_shipping]",
                        `<span class='cart-save-message__price'>${formatAmount(freeShippingLocal)}</span>`
                      );
                    }
                  }

                  if(emptyCartGift) {
                    if (enableCartGift) {
                      // Multi-GWP Empty cart message
                      const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
                        ? (freeShipping.cartGiftMinimumAmountLocal * 100)
                        : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;
                      
                      const emptyMessage = freeShipping.cartGiftProgressInfo.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(cartGiftMinAmountLocal)}</span>`
                      );
                      emptyCartGift.innerHTML = emptyMessage;
                      if (emptyCartGift2) emptyCartGift2.innerHTML = "";
                    } else {
                      if (cartTotal >= promotion2Price && promotion2.enable && promotion2Indicator == 'true') {
                        // Both gifts qualify
                        emptyCartGift.innerHTML = freeShipping.gift_fs_12_quali;
                      } else {
                        // For empty cart, show both messages with their respective full amounts
                        const gift1Message = freeShipping.gift1Notquali.replace(
                          "[amount_gift]",
                          `<span class='cart-save-message__price'>${formatAmount(promotion1PriceLocal)}</span>`
                        );
                        const gift2Message = freeShipping.gift2Notquali.replace(
                          "[amount_gift]",
                          `<span class='cart-save-message__price'>${formatAmount(promotion2PriceLocal)}</span>`
                        );

                        if(emptyCartGift2){
                          emptyCartGift2.innerHTML = `${gift2Message}`;
                        }
                        if(emptyCartGift){
                          emptyCartGift.innerHTML = `${gift1Message}`;
                        }
                      }
                    }
                  }
                  document.querySelector('.cart-items__empty').style.display = "flex";
                  document.querySelector('.cart-notification__footer.footer__main').classList.add('hidden')
                  if(!document.getElementById('cart-items').classList.contains('hidden')) document.getElementById('cart-items').classList.add('hidden')
                  document.getElementById('cart-items').innerHTML = ""
                }
                  document.querySelector('.mini-cart-overlay').style.opacity = "0";
                  document.querySelector('.mini-cart-overlay').style.pointerEvents = "none";

                  let variantRadios = document.querySelectorAll('variant-radios');
                    variantRadios.forEach(function(variantRadio) {
                      variantRadio.initializeVariantPicker();
                    });


                    const variantPickers = document.querySelectorAll('.cart-item__variant-picker');
                    variantPickers.forEach(variantPicker => {
                      if(variantPicker.classList.contains('one-time')){
                        variantPicker.remove();
                      }else{
                        if (variantPicker.classList.contains('variant-picker__expanded')) {
                          variantPicker.classList.remove('variant-picker__expanded');
                          variantPicker.querySelector(".active-variant__drawer").innerHTML = ""
                        }
                      }
                    });


                    cartObj.quantityInput();
                    cartObj.initializeRemoveListeners();
                    cartObj.initCartGift();

                    if(fromElement == 'FROM_ADD_TO_CART') {
                        cartObj.open();
                    }
                }
            }).catch(error => {
                console.error('Error getting cart:', error);
            });
        }).catch(error => {
            console.error('Error validating promotion:', error);
        });


    } catch (error) {
        console.error('Error in renderContents:', error);
    } finally {
      observeShadowAndInjectStyle()
      console.log("addToCartSuccess")
      document.dispatchEvent(new CustomEvent('addToCartSuccess'));
      setTimeout(() => {
        if(this.forceRender){
          this.renderContents("",true);
        }else{
          this.isRendering = false;
          const overlay = document.querySelector('.mini-cart-overlay');
          overlay.style.opacity = "0";
          overlay.style.pointerEvents = "none";
        }
    }, 100); // Small delay to ensure all operations are complete
    }
  }

  // Inactive: code moved into Nosto App - Inscoder AC 2024-08-14
  addToCartNosto(e) {
    var cartObj = this;
    var nostoVariantID = e.target.attributes["data-variant-id"].value;
    document.querySelector('.mini-cart-overlay').style.opacity = "1";
    document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

    fetch('/cart/add.js', {
        body: JSON.stringify({ id: nostoVariantID, quantity: 1 }),
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
    })
    .then((response) => response.json())
    .then((response) => {
      cartObj.renderContents();
    });
  }

  quantityInput() {
    const reducer = (a, b) => a + b;
    // Add change event in each qty input to update item
    var cartObj = this;
    document.querySelectorAll('.cart-notification__body .quantity__input').forEach(qtyInput => {
      qtyInput.addEventListener('change', function() {
        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

        const thisValue = this.value
        const thisVariantID = this.getAttribute('variant-id')
        const thisLine = this.getAttribute('data-index')
        const updateData = { line: thisLine, quantity: thisValue }

          if(thisValue == 0) document.querySelector(`[data-variant-id="${thisVariantID}"]`).style.display = 'none'

          if(thisValue > 9) {
            this.classList.add('max-quantity-reach')
            document.querySelector('.mini-cart-overlay').style.opacity = "0";
            document.querySelector('.mini-cart-overlay').style.pointerEvents = "none";

            return
          }
          else {
            this.classList.remove('max-quantity-reach')
          }
          if(thisValue <= 9) {
            fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(updateData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Assuming the server responds with JSON
            })
            .then(data => {
                cartObj.renderContents(); // Render contents after processing the response
            })
            .catch(error => {
                console.log('Request failed', error);
            });
        }
      })
    })
  }

  async removeProduct(item) {
    item.preventDefault();
    item.stopPropagation(); // Add this line to prevent event bubbling

    if (this.isRendering) return; // Add this to prevent multiple executions

    var removeArray = [], cartObj = this;
    var itemId = item.target.getAttribute("data-item-id");
    if (!itemId) return; // Add validation

    removeArray[itemId] = 0;
    document.querySelector('.mini-cart-overlay').style.opacity = "1";
    document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

    try {
        await window.removeGiftProduct(removeArray);
        await this.renderContents();
    } catch (error) {
        console.error('Error removing product:', error);
    }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('#cart-icon-bubble') && !target.closest('[data-action="nosto-addtocart"]')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setScreenHeight() {
    // ios fix for 100vh
    var screenHeight = window.innerHeight;
    document.documentElement.style.setProperty("--screen-height", screenHeight + "px");
  }

  initializeRemoveListeners() {
    // Regular remove items
    this.removeItems = this.notification.querySelectorAll("[data-action='remove-item']")
    this.removeItems.forEach((removeButton) => {
      removeButton.addEventListener('click', this.removeProduct.bind(this))
    })

    // Claim items
    this.notification.querySelectorAll("[data-action='remove-item-claim']").forEach((removeButton) => {
      removeButton.addEventListener('click', async (e) => {
        e.preventDefault();
        const itemKey = e.target.getAttribute('data-line-id');
        const itemId = e.target.getAttribute('data-item-id');

        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

        await this.handleRemoveCartClaim(itemKey, itemId);
        this.renderContents();
      })
    })
  }
}

customElements.define('cart-notification', CartNotification);

class CartSubscription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.selectElement = this.querySelector(".cart-item__inner-subscription-select-sel");
    this.initHTML();

    const defaultText = this.querySelector('.cart-item__inner-subscription-default');
    const selectBox = this.querySelector('.cart-item__inner-subscription-select');
    const selectElement = selectBox.querySelector('.cart-item__inner-subscription-select-sel');

    this.addEventListener('click', function(e) {
      if(e.target != selectElement){
        this.classList.add("selected");
        if(!this.selectElement.value){
          const firstNonEmpty = Array.from(this.selectElement.options).find(opt => opt.value.trim() !== '');
          firstNonEmpty.selected = true;
          this.selectElement.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  async login() {
    window.rechargeSession = await recharge.auth.loginShopifyAppProxy();
  }

  async initHTML(){
    if(!window.rechargeSession){
      await this.login();
    }
    const rechargeSubscriptionText = this.dataset.rechargeSubscriptionText.replace("[","<a href='#'>").replace("]","</a>");
    const rechargeSubscriptionSaveLabel = this.dataset.rechargeSubscriptionSaveLabel;
    const productId = this.dataset.productId;
    const sellingPlanId = this.dataset.sellingPlanId;

    this.querySelector(".cart-item__inner-subscription-default").innerHTML = rechargeSubscriptionText;

    const plans = await recharge.plan.listPlans(window.rechargeSession, {
      external_product_id: productId
    });

    const for_plans = plans.plans.filter(item => item.channel_settings.api.display && item.type !== 'onetime')
                .sort((a, b) => b.sort_order - a.sort_order);
    if(for_plans && for_plans.length > 0){
      this.classList.remove("hidden")
      let optionHtml = `<optgroup label="${rechargeSubscriptionSaveLabel}">`;
      for (const plan of for_plans.reverse()) {
        if(plan.type == "subscription"){
          if(plan.external_plan_id == sellingPlanId){
            this.classList.add("selected");
            optionHtml += `<option selected value="${plan.external_plan_id}">${plan.title}</option>`
          }else{
            optionHtml += `<option value="${plan.external_plan_id}">${plan.title}</option>`
          }
        }
      }
      optionHtml += "</optgroup>"
      this.selectElement.insertAdjacentHTML('beforeend', optionHtml);


      this.selectElement.addEventListener("change", (event)=>{
        const select_plan_value = this.selectElement.value;
        const cart_item__block = this.closest(".cart-item__block");

        if(cart_item__block.dataset.lineItemKey){
          document.querySelector('.mini-cart-overlay').style.opacity = "1";
          document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

          const variantId = cart_item__block.dataset.variantId;
          const quantity = cart_item__block.querySelector("input.quantity__input").value;

          const removeData = {
            id: cart_item__block.dataset.lineItemKey,
            quantity: 0
          };

          // let removeRequest = fetch('/cart/change.js', {
          //   method: 'POST',
          //   credentials: 'same-origin',
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'X-Requested-With': 'XMLHttpRequest'
          //   },
          //   body: JSON.stringify(removeData)
          // }).then(res => {
          //   if (!res.ok) throw new Error('Remove request failed');
          //   return res.json();
          // });

          // let addData = {
          //   id: variantId,
          //   quantity: parseInt(quantity, 10)
          // };
          // if (select_plan_value) {
          //   addData.selling_plan = select_plan_value;
          // }

          // let addRequest = fetch('/cart/add.js', {
          //   method: 'POST',
          //   credentials: 'same-origin',
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'X-Requested-With': 'XMLHttpRequest'
          //   },
          //   body: JSON.stringify(addData)
          // }).then(res => {
          //   if (!res.ok) throw new Error('Add request failed');
          //   return res.json();
          // });

          // Promise.all([removeRequest, addRequest])
          //   .then(([removeDataResponse, addDataResponse]) => {
          //     const cartObj = document.querySelector('cart-notification');
          //     cartObj.renderContents("", "", addDataResponse.variant_id, cart_item__block.dataset.lineItemKey);
          //   })
          //   .catch(error => {
          //     console.error('Request failed', error);
          //   });


          fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(removeData)
          }).then(res => {
            if (!res.ok) throw new Error('Remove request failed');
            return res.json();
          }).then(removeDataResponse => {
          let addData = {
            id: variantId,
            quantity: parseInt(quantity, 10)
          };
          if (select_plan_value) addData.selling_plan = select_plan_value;

          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(addData)
          });
        })
        .then(res => {
          if (!res.ok) throw new Error('Add request failed');
          return res.json();
        })
        .then(addDataResponse => {
          const cartObj = document.querySelector('cart-notification');
          cartObj.renderContents("", "", addDataResponse.variant_id, cart_item__block.dataset.lineItemKey);
        })
        .catch(error => {
          console.error('Request failed', error);
        });
        }
      })
    }
  }
}

customElements.define('cart-subscription', CartSubscription);


observeShadowAndInjectStyle();


(function () {
  function injectStyleToProtectionModal(host) {
    if (!host || host.__styleObserverInited) return;
    host.__styleObserverInited = true;

    const startObserveShadow = () => {
      if (!host.shadowRoot) return false;

      const shadow = host.shadowRoot;

      const applyStyle = () => {
        const target = shadow.querySelector('#modal-dialog');

        if (target && !shadow.querySelector('#custom-style')) {
          const style = document.createElement('style');
          style.id = 'custom-style';
          style.textContent = `
            .complex-text-media-block > div {
              display: inline !important;
            }
            .complex-text-media-icon{
              margin-right: 5px;
            }
          `;
          shadow.appendChild(style);
        }
      };

      applyStyle();

      const shadowObserver = new MutationObserver(() => {
        applyStyle();
      });

      shadowObserver.observe(shadow, {
        childList: true,
        subtree: true
      });

      return true;
    };

    if (!startObserveShadow()) {
      const waitShadow = setInterval(() => {
        if (startObserveShadow()) {
          clearInterval(waitShadow);
        }
      }, 50);
    }
  }

  document.querySelectorAll('protection-modal').forEach(injectStyleToProtectionModal);

  const pageObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches && node.matches('protection-modal')) {
          injectStyleToProtectionModal(node);
        }

        if (node.querySelectorAll) {
          node.querySelectorAll('protection-modal').forEach(injectStyleToProtectionModal);
        }
      }
    }
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();